module.exports = "../study/imgs/maps/Tokyo/S8/Agriculture/Rice/Tokyo_Rice_MIROC5_RCP85_Mid.png";